import { TFunction } from "i18next";

const BASE = "dashboard.entities.viewEntityUser.sendWhatsApp";

const QUALITY_KEYS: Record<string, string> = {
  high: "green",
  green: "green",
  medium: "yellow",
  yellow: "yellow",
  low: "red",
  red: "red",
};

export const senderQualityLabel = (
  quality: string | null | undefined,
  t: TFunction
): string | null => {
  const key = QUALITY_KEYS[String(quality ?? "").toLowerCase()];
  if (!key) return null;
  return t(`${BASE}.quality.${key}`) as string;
};

export const senderStatusLabel = (
  status: string | null | undefined,
  t: TFunction
): string | null => {
  const raw = String(status ?? "").trim();
  if (!raw) return null;
  const label = t(`${BASE}.senderStatus.${raw}`, {
    defaultValue: "",
  }) as string;
  return label || null;
};
